import React, { useState, useEffect } from 'react';
import { create } from 'zustand';
import { getNutritionLogsForUsers } from 'src/queries/nutrition';

export const useNutrition = create((set, get) => {
  return {
    logs: [],
    loadingLogs: true,
    setLoading: (newVal) => {
      return set({ loadingLogs: newVal });
    },
    setLogs: (newLogs) => {
      return set({ logs: newLogs });
    },
    mostRecentLogs: [],
    setMostRecentLogs: (newLogs) => {
      return set({ mostRecentLogs: newLogs });
    },
    getNutritionLogsForUsers: (appUsers) => {
      const { getMostRecentLogsByUser } = get();
      set({ loadingLogs: true });
      getNutritionLogsForUsers(appUsers, (logs) => {
        getMostRecentLogsByUser(appUsers, logs);
        return set({ loadingLogs: false, logs });
      });
    },
    getMostRecentLogsByUser: (appUsers, logs) => {
      const recentLogs = appUsers.map((user) => {
        const userLogs = [...logs].filter((log) => log.username === user.username);
        const mostRecentLog = userLogs.reduce((prev, current) => {
          if (!prev || current.dateAndTimeSubmitted > prev.dateAndTimeSubmitted) {
            return current;
          }
          return prev;
        }, null);

        return mostRecentLog;
      });
      return set({ mostRecentLogs: recentLogs });
    },
  };
});
